import Dashboard from '../components/dashboard/Dashboard';
import GameRules from "@/components/dashboard/GameRules";
import Toplist from '../components/dashboard/Toplist';
import News from '../components/dashboard/News';

export default [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
  },
  {
    name: 'GameRules',
    path: '/gameRules',
    component: GameRules,
  },
  {
    name: 'Toplist',
    path: '/toplist',
    component: Toplist,
  },
  {
    name: 'News',
    path: '/news',
    component: News,
  },
]
